import { Image, type ImageProps } from "@medbillai/ui";

// TODO: Remove after template / login flow ticket
export const GradientUnderlayImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/gradient-underlay.png`
  }} height={100} width={150} {...props} data-sentry-element="Image" data-sentry-component="GradientUnderlayImage" data-sentry-source-file="LocalImages.tsx" />;
};

// TODO: Remove after template / login flow ticket
export const GradientBackgroundImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/gradientOverlayBackground.png`
  }} {...props} data-sentry-element="Image" data-sentry-component="GradientBackgroundImage" data-sentry-source-file="LocalImages.tsx" />;
};
export const InsuranceLogoGridBackground = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/insuranceHomeLogos.png`
  }} width={838} height={700} objectFit="fill" {...props} data-sentry-element="Image" data-sentry-component="InsuranceLogoGridBackground" data-sentry-source-file="LocalImages.tsx" />;
};
export const GrantedLogo = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/grantedLogo.png`
  }} {...props} data-sentry-element="Image" data-sentry-component="GrantedLogo" data-sentry-source-file="LocalImages.tsx" />;
};
export const AnthemCardLogo = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/card-logos/anthemHiRes.png`
  }} width={140} height={22} {...props} data-sentry-element="Image" data-sentry-component="AnthemCardLogo" data-sentry-source-file="LocalImages.tsx" />;
};
export const NotificationBackgroundImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/notificationBackground.png`
  }} width={326} height={87} {...props} data-sentry-element="Image" data-sentry-component="NotificationBackgroundImage" data-sentry-source-file="LocalImages.tsx" />;
};
export const MedicaCardLogo = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/card-logos/medicaHiRes.png`
  }} width={120} height={22} {...props} data-sentry-element="Image" data-sentry-component="MedicaCardLogo" data-sentry-source-file="LocalImages.tsx" />;
};
export const AetnaCardLogo = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/card-logos/aetnaHiRes.png`
  }} width={107} height={22} {...props} data-sentry-element="Image" data-sentry-component="AetnaCardLogo" data-sentry-source-file="LocalImages.tsx" />;
};
export const BackgroundBlueGradient = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/backgroundBlueGradient.png`
  }} width="100%" height={300} {...props} data-sentry-element="Image" data-sentry-component="BackgroundBlueGradient" data-sentry-source-file="LocalImages.tsx" />;
};
export const BackgroundGreenGradient = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/backgroundGreenGradient.png`
  }} width="100%" height={300} {...props} data-sentry-element="Image" data-sentry-component="BackgroundGreenGradient" data-sentry-source-file="LocalImages.tsx" />;
};
export const BackgroundGreenGradientCircle = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/backgroundGreenGradientCircle.png`
  }} width="100%" height={300} {...props} data-sentry-element="Image" data-sentry-component="BackgroundGreenGradientCircle" data-sentry-source-file="LocalImages.tsx" />;
};
export const InsuranceCardImageBlock = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/insuranceCardImageBlock.png`
  }} height={400} width={400} mb={-100} objectFit="contain" resizeMode="contain" {...props} data-sentry-element="Image" data-sentry-component="InsuranceCardImageBlock" data-sentry-source-file="LocalImages.tsx" />;
};
export const AppIcon = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/icon.png`
  }} objectFit="contain" width={100} height={100} {...props} data-sentry-element="Image" data-sentry-component="AppIcon" data-sentry-source-file="LocalImages.tsx" />;
};
export const FacebookIcon = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/logos/facebook.png`
  }} objectFit="contain" width={100} height={100} {...props} data-sentry-element="Image" data-sentry-component="FacebookIcon" data-sentry-source-file="LocalImages.tsx" />;
};
export const InstagramIcon = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/logos/instagram.png`
  }} objectFit="contain" width={100} height={100} {...props} data-sentry-element="Image" data-sentry-component="InstagramIcon" data-sentry-source-file="LocalImages.tsx" />;
};
export const GoogleIcon = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/logos/google.png`
  }} objectFit="contain" width={100} height={100} {...props} data-sentry-element="Image" data-sentry-component="GoogleIcon" data-sentry-source-file="LocalImages.tsx" />;
};
export const GettingStartedImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/gettingStarted.png`
  }} width={1169} height={654} {...props} data-sentry-element="Image" data-sentry-component="GettingStartedImage" data-sentry-source-file="LocalImages.tsx" />;
};
export const ChatBubbleImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/chatBubble.png`
  }} width={204} height={204} {...props} data-sentry-element="Image" data-sentry-component="ChatBubbleImage" data-sentry-source-file="LocalImages.tsx" />;
};
export const OnboardingBackgroundGreenImage = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/backgroundOnboardingGreen.jpg`
  }} {...props} data-sentry-element="Image" data-sentry-component="OnboardingBackgroundGreenImage" data-sentry-source-file="LocalImages.tsx" />;
};
export const ChatIconLogo = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/chatIconLogo.png`
  }} width={330} height={330} {...props} data-sentry-element="Image" data-sentry-component="ChatIconLogo" data-sentry-source-file="LocalImages.tsx" />;
};
export const BillHelpBadge = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/billHelpBadge.png`
  }} width={52} height={76} {...props} data-sentry-element="Image" data-sentry-component="BillHelpBadge" data-sentry-source-file="LocalImages.tsx" />;
};
export const CoverageCheckBadge = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/coverageCheckBadge.png`
  }} width={52} height={76} {...props} data-sentry-element="Image" data-sentry-component="CoverageCheckBadge" data-sentry-source-file="LocalImages.tsx" />;
};
export const OpenEnrollmentBadge = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/openEnrollmentBadge.png`
  }} width={52} height={76} {...props} data-sentry-element="Image" data-sentry-component="OpenEnrollmentBadge" data-sentry-source-file="LocalImages.tsx" />;
};
export const SomethingElseBadge = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/somethingElseBadge.png`
  }} width={52} height={76} {...props} data-sentry-element="Image" data-sentry-component="SomethingElseBadge" data-sentry-source-file="LocalImages.tsx" />;
};
export const GradientStar = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/star_optimized.png`
  }} width={30} height={30} {...props} data-sentry-element="Image" data-sentry-component="GradientStar" data-sentry-source-file="LocalImages.tsx" />;
};
export const PaymentCards = (props: Omit<ImageProps, "source">) => {
  return <Image source={{
    uri: `/static/paymentCards.png`
  }} width="100%" height={undefined} aspectRatio={808 / 544} objectFit="contain" {...props} data-sentry-element="Image" data-sentry-component="PaymentCards" data-sentry-source-file="LocalImages.tsx" />;
};